<template>
  <div class="sub-container">
    <v-card class="mx-6 mt-0" color="#433876" variant="flat" height="60px">
      <v-card-actions>
        <span class="mt-0 ml-2 head-sub-text">
          <v-icon class="mx-2">
            {{ routeParams ? "mdi-pencil" : "mdi-account" }}
          </v-icon>
          {{ routeParams ? "Edit" : "Add" }} List
        </span>

        <v-spacer />
        <v-btn color="#45b6c2" variant="flat" class="btn-text" size="small" :to="{ name: 'ListPage' }">
          <span class="btn-text">
            <v-icon class="mx-2">mdi-eye</v-icon>
            View All lists
          </span>
        </v-btn>

        <v-btn color="purple" variant="flat" class="btn-text" size="small" :to="{ name: 'AddList' }">
          <span class="btn-text">
            <v-icon class="mx-2">mdi-file-plus</v-icon>
            Add New List
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card variant="flat" class="mx-6 mt-0">
      <v-card-text class="mt-6">
        <v-form ref="subForm" v-model="isValid">
          <v-row class="mt-n6">
            <!-- <v-col class="mx-3 mt-3" :cols="12" :md="2" :sm="3"
              >List name</v-col
            > -->
            <v-col :cols="12" :md="6" :sm="3" align-self="start"><v-text-field class="mt-2 mx-auto" ref="fname"
                label="List Name" placeholder="Add a List Name" :rules="rules.required" v-model="formData.name"
                density="compact" style="color: #3c3731" variant="outlined" /></v-col></v-row>
          <v-row class="mt-n6">
            <!-- <v-col class="mx-3" :cols="12" :md="2" :sm="3">Description</v-col
            > -->
            <v-col :cols="12" :md="6" :sm="3" align-self="start"><v-text-field class="mt-2 mx-auto" ref="lname"
                :rules="rules.required" v-model="formData.description" density="compact" style="color: #3c3731"
                label="Description" placeholder="Add a Description" variant="outlined" /></v-col></v-row>
        </v-form>

        <v-card-actions class="ml-0 mt-2">
          <v-btn @click="routeParams ? edit() : save()" color="success" size="small" variant="flat">
            <span class="btn-text" v-if="!loadingState">
              <v-icon>mdi-content-save</v-icon> save List</span>
            <v-progress-circular :width="2" color="#355E3B" indeterminate v-if="loadingState"></v-progress-circular>
          </v-btn>

          <!-- <v-btn
          color="#343a40"
          width="80"
          variant="flat"
          size="small"
          :to="{ name: 'ListPage' }"
        >
          <span class="btn-text"><v-icon class="">mdi-close</v-icon>Cancel</span>
        </v-btn> -->
        </v-card-actions>
      </v-card-text>
      <editSubsPage :routeId="routeId" v-if="routeParams" />
    </v-card>
  </div>
</template>

<script>
import editSubsPage from "@/modules/subscribers/components/editSubsPage.vue";
import eventBus from "@/utils/eventBus";
export default {
  name: "addList",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("subscribers/getLists");
      // v.$store.dispatch("subscribers/getSubscribers");
      if (v.$route.params.id !== "") {
        v.$store.dispatch("list/getSingleList", parseInt(v.$route.params.id));
      
      }
    });
  },
  components: { editSubsPage },

  data() {
    return {
      isValid: false,

      allSubscribers: [],
      loadingState: false,
      screenSize: "",
      oldValue: false,
      test: [],
      newFiltered: [],
      formData: {
        name: "",
        description: "",
        subscribers: [],
      },

      rules: {
        required: [(value) => !!value || "Required."],
        email: [
          (value) => !!value || "Required.",
          (value) => /.+@.+\..+/.test(value) || "Invalid email address.",
        ],
        password: [(value) => !!value || "Required."],
      },
    };
  },

  computed: {
    formattedName() {
      return (item) => `${item.first_name} ${item.last_name}`;
    },
    lists() {
      return this.$store.getters["subscribers/subscribersGetters"]("Lists");
    },
    loaderState() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "loaderState"
      );
    },
    subscribers() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "subscribers"
      );
    },
    subscribersByID() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "filteredSubs"
      );
    },
    singleList() {
      return this.$store.getters["list/listGetters"]("singleList").subscribers;
    },

    routeParams() {
      return !!this.$route.params.id;
    },
    routeId() {
      return parseInt(this.$route.params.id);
    },

    listEdited() {
      return this.lists
        ? this.lists
          .filter((f) => f.id === parseInt(this.$route.params.id))
          .shift()
        : {};
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
    eventBus.on("redirectToList", () => {
      this.$router.push({ name: "ListPage" });
    });
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
    save() {
      if (!this.isValid) {
        this.$refs.subForm.validate();
      } else {
        this.formData.subscribers = [...this.newFiltered];
        this.$store.dispatch("list/saveList", this.formData);
      }
    },

    edit() {
      if (!this.isValid) {
        this.$refs.subForm.validate();
      } else {
        this.formData.listId = parseInt(this.$route.params.id);
        this.formData.subscribers = [...this.newFiltered];

        this.$store.dispatch("list/editList", this.formData);
      }
    },

    getObject(val) {
      console.log(val);
      return val;
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },
    listEdited: {
      handler: function () {
        if (this.listEdited !== "undefined") {
          this.formData = { ...this.listEdited };
        }
      },
    },
    test: {
      handler: function () {
        const subscriberIds = this.test.map((subscriber) => subscriber.id);
        this.allSubscribers = [...subscriberIds];
      },
      immediate: true,
    },
    allSubscribers: {
      handler: function () {
        if (this.allSubscribers.length > 0) {
          let filteredObjects = [];
          this.allSubscribers.forEach((id) => {
            let obj = this.test.find((item) => item.id === id);
            if (obj) {
              delete obj.groups,
                delete obj.is_subscribed,
                delete obj.is_blacklisted,
                filteredObjects.push(obj);
            }
          });
          this.newFiltered = filteredObjects;
        }
      },
      immediate: true,
    },
    singleList: {
      handler: function () {
        const subscriberIds2 = this.singleList.map(
          (subscriber) => subscriber.id
        );
        this.allSubscribers = [...subscriberIds2];
      },
    },
  },
};
</script>

<style>
@import url("../listStyles.css");
</style>
